import Select from "react-select"
import React, { Fragment } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  CardTitle,
  Label,
} from "reactstrap"
export const DateRangeCard = props => {
  return (
    <Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4"></CardTitle>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Row>
                <Col lg={5}>
                  <div className="row mb-4">
                    <Col sm={9} md={2} lg={2}>
                      <Label
                        htmlFor="horizontal-firstname-Input"
                        className="col-sm-3 col-form-label text-nowrap"
                      >
                        From
                      </Label>
                    </Col>
                    <Col sm={3} md={6} lg={10}>
                      <Input
                        onChange={e => props.setFrom(e.target.value)}
                        type="date"
                        className="form-control"
                        id="horizontal-firstname-Input"
                      />
                    </Col>
                  </div>
                </Col>
                <Col lg={5}>
                  <div className="row mb-4">
                    <Col sm={9} md={2} lg={2}>
                      <Label
                        htmlFor="horizontal-email-Input"
                        className="col-sm-3 col-form-label text-nowrap"
                      >
                        To
                      </Label>
                    </Col>
                    <Col sm={9} md={6} lg={10}>
                      <Input
                        onChange={e => props.setTo(e.target.value)}
                        type="date"
                        className="form-control"
                        id="horizontal-email-Input"
                      />
                    </Col>
                  </div>
                </Col>

                <Col lg={2}>
                  <div className="row mb-4">
                    <Col sm={9} md={2} lg={2}></Col>
                    <Col sm={9} md={6} lg={10}>
                      <div>
                        <Button
                          type="button"
                          onClick={() => {
                            props.call()
                          }}
                          color="primary"
                          className="w-md"
                        >
                          Search
                        </Button>
                      </div>
                    </Col>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Fragment>
  )
}
